import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import { CounterState } from './state';
import { counterGetters } from './getters';
import { counterMutations } from './mutations';
import { counterActions } from './actions';

Vue.use(Vuex);

export const counter = {
  namespaced: true,
  state: new CounterState(),
  getters: counterGetters,
  mutations: counterMutations,
  actions: counterActions,
} as StoreOptions<CounterState>;

export * from './types';
export * from './state';
export default counter;
